<div class="badge-container">
  <button class="avatar-btn" (click)="profilePanel.toggle($event)" [attr.aria-label]="fullName">
    {{ initials }}
  </button>
</div>

<p-popover #profilePanel styleClass="glass-profile-panel" appendTo="body">
  <div class="profile-card">

    <!-- Avatar + name + email -->
    <div class="profile-header">
      <div class="profile-avatar-lg">{{ initials }}</div>
      <div class="profile-identity">
        <div class="profile-name-row">
          <span class="profile-name">{{ fullName }}</span>
          @if (isAdmin$ | async) {
            <span class="profile-admin-badge">Admin</span>
          }
        </div>
        <span class="profile-email">{{ email }}</span>
      </div>
    </div>

    <!-- Org(s) -->
    @if (userOrgs.length > 0) {
      <div class="profile-section">
        <span class="profile-section-label">Orgs assigned to you:</span>
        <div class="profile-orgs">
          @for (org of userOrgs; track org) {
            <span class="profile-org-badge">{{ org }}</span>
          }
        </div>
      </div>
    }

    <!-- Teams -->
    <div class="profile-section">
      <span class="profile-section-label">Teams assigned to you:</span>
      @if (userTeams.length > 0) {
        <div class="profile-teams">
          @for (team of userTeams; track team._id) {
            <div class="profile-team-row">
              <span class="profile-team-name">{{ team.name }}</span>
            </div>
          }
        </div>
      } @else {
        <p class="profile-no-teams">Not assigned to any teams yet.</p>
      }
    </div>

    <hr class="profile-divider">

    <!-- CMR Subscriptions -->
    <div class="profile-section">
      <div class="profile-section-header">
        <span class="profile-section-label">CMR Subscriptions</span>
        @if (subscriptions.length > 0) {
          <span class="profile-sub-count">{{ subscriptions.length }}</span>
        }
      </div>
      <p-button label="Manage Subscriptions" icon="pi pi-eye" size="small" [text]="true"
        styleClass="w-full sub-manage-btn" (onClick)="openSubscriptions()">
      </p-button>
    </div>

    <hr class="profile-divider">

    <!-- Logout -->
    <div class="profile-footer">
      <p-button label="Sign out" icon="pi pi-sign-out" severity="secondary"
        size="small" [text]="true" (onClick)="logout()">
      </p-button>
    </div>

  </div>
</p-popover>

<!-- Subscriptions Modal -->
<p-dialog
  [(visible)]="showSubscriptionsModal"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '520px', maxWidth: '95vw' }"
  header="My CMR Subscriptions">

  @if (isLoadingSubscriptions) {
    <p class="sub-modal-loading">Loading subscriptions…</p>
  } @else if (subscriptions.length === 0) {
    <div class="sub-modal-empty">
      <i class="pi pi-eye-slash sub-modal-empty-icon"></i>
      <p>You have no active subscriptions.</p>
      <p class="sub-modal-empty-hint">Click the <i class="pi pi-eye-slash"></i> icon next to a CMR title, team, or component in the requests list to subscribe.</p>
    </div>
  } @else {
    <div class="sub-modal-content">

      @if (subscribedCmrs.length > 0) {
        <div class="sub-group">
          <span class="sub-group-label">CMRs</span>
          @for (sub of subscribedCmrs; track sub._id) {
            <div class="sub-row">
              <i class="pi pi-file sub-row-icon"></i>
              <span class="sub-row-label">{{ sub.targetLabel }}</span>
              <button class="sub-remove-btn" (click)="unsubscribe(sub)" title="Unsubscribe">
                <i class="pi pi-times"></i>
              </button>
            </div>
          }
        </div>
      }

      @if (subscribedTeams.length > 0) {
        <div class="sub-group">
          <span class="sub-group-label">Teams</span>
          @for (sub of subscribedTeams; track sub._id) {
            <div class="sub-row">
              <i class="pi pi-users sub-row-icon"></i>
              <span class="sub-row-label">{{ sub.targetLabel }}</span>
              <button class="sub-remove-btn" (click)="unsubscribe(sub)" title="Unsubscribe">
                <i class="pi pi-times"></i>
              </button>
            </div>
          }
        </div>
      }

      @if (subscribedComponents.length > 0) {
        <div class="sub-group">
          <span class="sub-group-label">Components</span>
          @for (sub of subscribedComponents; track sub._id) {
            <div class="sub-row">
              <i class="pi pi-box sub-row-icon"></i>
              <span class="sub-row-label">{{ sub.targetLabel }}</span>
              <button class="sub-remove-btn" (click)="unsubscribe(sub)" title="Unsubscribe">
                <i class="pi pi-times"></i>
              </button>
            </div>
          }
        </div>
      }

    </div>
  }

</p-dialog>
